export default __webpack_public_path__ + "static/media/card-membership.ef8bfde4.png";